export default class PageVisibilityManager {
    private registeredCallbacks: Record<number, (isVisible: boolean) => void>;

    private hidden: string | undefined;

    private visibilityChange: string | undefined;

    constructor() {
        // support for older browsers
        if (typeof document.hidden !== "undefined") {
            this.hidden = "hidden";
            this.visibilityChange = "visibilitychange";
        } else if ("msHidden" in window) {
            this.hidden = "msHidden";
            this.visibilityChange = "msvisibilitychange";
        } else if ("webkitHidden" in window) {
            this.hidden = "webkitHidden";
            this.visibilityChange = "webkitvisibilitychange";
        }

        this.registeredCallbacks = [];

        // log to the console if the browser doesn't support addEventListener or the visibility API
        if (typeof document.addEventListener === "undefined" || typeof this.hidden === "undefined") {
            console.error("This browser doesn't support the Page Visibility API");
        } else {
            // register the event listener
            document.addEventListener(this.visibilityChange!, this.handleVisibilityChange.bind(this), { capture: true });
        }
    }

    public registerCallback(cb: (isVisible: boolean) => void): number {
        const registrationKey = Date.now();
        this.registeredCallbacks[registrationKey] = cb;

        return registrationKey;
    }

    public unregisterCallback(registrationKey: number): boolean {
        try {
            return delete this.registeredCallbacks[registrationKey];
        } catch (_e) {
            return false;
        }
    }

    private handleVisibilityChange(): void {
        if (document[this.hidden as keyof Document]) {
            // hidden

            Object.values(this.registeredCallbacks).forEach((cb) => cb(false));
        } else {
            // visible

            Object.values(this.registeredCallbacks).forEach((cb) => cb(true));
        }
    }
}
